
import jQuery from 'jquery';


var MultiCheckboxInput = function(element) {
  this.element = element;

  this.onCheckboxChange = this.onCheckboxChange.bind(this);
};
MultiCheckboxInput.prototype.initialise = function() {
  this.input = this.element.find('[data-sbm-mci-input]');
  this.checkboxes = this.element.find('[data-sbm-mci-checkbox]');

  this.checkboxes.on('change', this.onCheckboxChange);
};
MultiCheckboxInput.prototype.onCheckboxChange = function() {
  var result = [];
  var allChecked = true;

  for (var i = 0; i < this.checkboxes.length; i++) {
    var element = this.checkboxes[i];

    if (element.checked) {
      result.push(element.value);
    } else {
      allChecked = false;
    }
  }

  if (allChecked) {
    this.input.val('');
  } else {
    this.input.val(result.join(','));
  }
};


jQuery(window).on('load', function() {
  var items = jQuery('[data-sbm-multi-checkbox-input]');

  if (items.length) {
    for (var i = 0; i < items.length; i++) {
      var item = jQuery(items[i]);

      var block = new MultiCheckboxInput(item);
      block.initialise();
    }
  }
});

